import { useCallback } from 'react';
import { useDispatch } from 'core/common/hooks';
import { AnyOffersAttributes } from '../entities';
import { fetchOffersByCategory } from '../store/actions';

type UseFetchOffersParams = {
  offersAttributes: Array<AnyOffersAttributes>;
};

export function useFetchOffers({ offersAttributes }: UseFetchOffersParams) {
  const dispatch = useDispatch();

  const doFetchOffers = useCallback(async () => {
    await dispatch(fetchOffersByCategory(offersAttributes));
  }, [dispatch, offersAttributes]);

  return {
    fetchOffers: doFetchOffers,
  };
}
